export const scrollToBottomHeader = (el) => {
    const headerHeight = 38 + 66 + 6;
    // 38 is search bar height
    // 66 is header bar height
    // 6 is space between header and element to get perfect view
    window.scrollTo({
        top: el.getBoundingClientRect().top + window.pageYOffset - headerHeight,
        behavior: "smooth",
    });
};

